'use strict';

import * as dom from './lib/dom.js';

function activeAuthor(event) {
    event.preventDefault();

    const thisEl = event.target;
    const elInfo = dom.findTarget(thisEl, 'js-about__author-item');
    const elContent = document.querySelector('.js-about__author-item-content');
    const allEl = document.querySelectorAll('.js-about__author-item');

    dom.forEachEl(allEl, (el) => {
        dom.removeClass(el, 'c-podcasts-archive__author-item--cloned');
    });

    dom.addClass(elInfo, 'c-podcasts-archive__author-item--cloned');
    elContent.innerHTML = null;
    dom.forEachEl(elInfo.children, (children) => {
        const elInfoDom = children.cloneNode(true);
        elContent.appendChild(elInfoDom);
    });


}

export default function(){
    const authorItem = document.querySelectorAll('.js-about__author-item');
    dom.forEachEl(authorItem, (el) => {
        dom.removeClass(el, 'c-podcasts-archive__author-item--cloned');
        el.addEventListener('click', activeAuthor);
    });
}
